import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { MainService } from "core/main.service";
import { PreferencesService } from "core/preferences.service";
import { ApplicationState, State } from "core/volatile-application-state.model";
import { combineLatest, Subject } from "rxjs";
import { Breakpoint, LayoutService } from "core/layout.service";
import { takeUntil } from "rxjs/operators";
import { AsyncPipe, NgClass } from "@angular/common";
import { WorkspaceNavigationComponent } from "navigation/workspace/workspace-navigation.component";
import { NavigationComponent } from "navigation/list/navigation.component";
import { ClipboardComponent } from "navigation/list/clipboard/clipboard.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "stages-navigation-drawer",
	templateUrl: "./navigation-drawer.component.html",
	imports: [NgClass, WorkspaceNavigationComponent, NavigationComponent, ClipboardComponent, TranslateModule, AsyncPipe],
})
export class NavigationDrawerComponent implements OnDestroy, OnInit {
	private preferencesService = inject(PreferencesService);
	protected layoutService = inject(LayoutService);
	private mainService = inject(MainService);

	private prefKey: string = "navigationDrawerState"; // navigationDrawerOpen is a legacy boolean value
	private destroy$ = new Subject<boolean>();
	applicationState: ApplicationState;
	isNavigationDrawerOpen: boolean = true;

	constructor() {
		const mainService = inject(MainService);

		this.applicationState = mainService.applicationState;
	}

	// eslint-disable-next-line @typescript-eslint/no-misused-promises -- TODO: Remove this comment and fix warnings!
	async ngOnInit(): Promise<void> {
		const preference = await this.preferencesService.getPreference(this.prefKey, { value: State.RESPONSIVE });
		this.applicationState.navigationDrawerOpen = preference.value;

		combineLatest([this.layoutService.breakpoint, this.mainService.applicationState.navigationDrawerState$])
			.pipe(takeUntil(this.destroy$))
			.subscribe(([breakpoint, state]) => {
				if (!breakpoint.isMobile && state === State.FORCE_OPENED) {
					this.applicationState.navigationDrawerOpen = State.RESPONSIVE;
					this.preferencesService.setPreference(this.prefKey, { value: this.applicationState.navigationDrawerOpen });
					return;
				}

				if (state === State.FORCE_CLOSED) {
					this.isNavigationDrawerOpen = false;
				} else if (state === State.FORCE_OPENED) {
					this.isNavigationDrawerOpen = true;
				} else {
					this.isNavigationDrawerOpen = !breakpoint.isMobile;
				}
			});
	}

	ngOnDestroy(): void {
		this.destroy$.next(true);
		this.destroy$.complete();
	}

	toggleMenu(_breakpoint: Breakpoint): void {
		this.applicationState.navigationDrawerOpen = this.isNavigationDrawerOpen ? State.FORCE_CLOSED : State.FORCE_OPENED;
		this.preferencesService.setPreference(this.prefKey, { value: this.applicationState.navigationDrawerOpen });
	}

	protected readonly State = State;
}
